import React, { useEffect } from 'react';
import styles from './Projects.module.css';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import odoo1 from '../../assets/odoo/odoo1.jpeg';
import odoo2 from '../../assets/odoo/odoo2.jpeg';
import odoo3 from '../../assets/odoo/odoo3.jpeg';
import odoo4 from '../../assets/odoo/odoo4.jpeg';
import odoo5 from '../../assets/odoo/odoo5.jpeg';
import odoo6 from '../../assets/odoo/odoo6.jpeg';
import odoo7 from '../../assets/odoo/odoo7.jpeg';
import odoo8 from '../../assets/odoo/odoo8.jpeg';
import flutter0 from '../../assets/flutter/flutter0.jpeg';
import flutter1 from '../../assets/flutter/flutter1.jpeg';
import flutter2 from '../../assets/flutter/flutter2.jpeg';
import flutter3 from '../../assets/flutter/flutter3.jpeg';
import flutter4 from '../../assets/flutter/flutter4.jpeg';
import flutter5 from '../../assets/flutter/flutter5.jpeg';
import flutter6 from '../../assets/flutter/flutter6.jpeg';
import flutter7 from '../../assets/flutter/flutter7.jpeg';
import flutter8 from '../../assets/flutter/flutter8.jpeg';
import flexi1 from '../../assets/flexi/flexi1.jpeg';
import flexi2 from '../../assets/flexi/flexi2.png';
import flexi3 from '../../assets/flexi/flexi3.png';
import flexi4 from '../../assets/flexi/flexi4.png';
import flexi5 from '../../assets/flexi/flexi5.png';
import flexi6 from '../../assets/flexi/flexi6.jpeg';
import flexi7 from '../../assets/flexi/flexi7.jpeg';
import flexi8 from '../../assets/flexi/flexi8.jpeg';
import flexi9 from '../../assets/flexi/flexi9.jpeg';
import i18n from '../../i18n';

const odooImages = [odoo1, odoo2, odoo3, odoo4, odoo5, odoo6, odoo7, odoo8];
const flutterImages = [flutter1, flutter0, flutter2, flutter3, flutter4, flutter5, flutter6, flutter7, flutter8];
const flexiImages = [flexi1, flexi2, flexi3, flexi4, flexi5, flexi6, flexi7, flexi8, flexi9];

export const Projects: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .swiper-pagination-bullet {
        background-color: black !important;
        width: 8px;
        height: 8px;
        opacity: 1;
        margin: 0 4px;
      }

      .swiper-pagination-bullet-active {
        background-color: #a020f0 !important;
        transform: scale(1.3);
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <section className={styles.projects} id="projekte" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      <h2>{t('projects.title')}</h2>
      <div className={styles.colmon}>

        {/* مشروع Odoo */}
        <div className={styles.project}>
          <div className={styles.text}>
            <h3>{t('projects.odoo.title')}</h3>
            <p>{t('projects.odoo.description')}</p>
            <ul>
              <li>✓ {t('projects.odoo.feature1')}</li>
              <li>✓ {t('projects.odoo.feature2')}</li>
              <li>✓ {t('projects.odoo.feature3')}</li>
              <li>✓ {t('projects.odoo.feature4')}</li>
              <li>✓ {t('projects.odoo.feature5')}</li>
              <li>✓ <span className={styles.more}> {t('projects.odoo.more')}</span></li>

            </ul>
            <span className={styles.tech}>{t('projects.odoo.technologies')}</span>
          </div>

          <div className={styles.images}>
            <Swiper
              key={i18n.language}
              className={styles.customSwiper}
              navigation={{
                nextEl: '.custom-next',
                prevEl: '.custom-prev',
              }}
              pagination={{ clickable: true }}
              loop={true}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              modules={[Autoplay, Pagination, Navigation]}
            >
              {odooImages.map((src, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={src}
                    alt={`Project Image ${index + 1}`}
                    className={styles.projectImage}
                    style={{
                      width: '100%',
                      
                      height: 'auto',
                      maxHeight: '300px',
                      objectFit: 'contain',
                      borderRadius: '10px',
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="custom-prev" style={{ color: '#2c2c2c', fontSize: '3rem', position: 'absolute', top: '50%', left: 10, zIndex: 10, cursor: 'pointer' }}>‹</div>
            <div className="custom-next" style={{ color: '#2c2c2c', fontSize: '3rem', position: 'absolute', top: '50%', right: 10, zIndex: 10, cursor: 'pointer' }}>›</div>
          </div>
        </div>

        {/* مشروع Flutter */}
        <div className={styles.project}>
          <div className={styles.images}>
            <Swiper
              key={i18n.language}
              className={styles.customSwiper}
              navigation={{
                nextEl: '.custom-next',
                prevEl: '.custom-prev',
              }}
              pagination={{ clickable: true }}
              loop={true}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              modules={[Autoplay, Pagination, Navigation]}
            >
              {flutterImages.map((src, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={src}
                    alt={`Project Image ${index + 1}`}
                    className={styles.projectImage}
                    style={{
                      width: '41%',

                      height: 'auto',
                      maxHeight: '300px',
                                            objectFit: 'contain',
                      borderRadius: '10px',
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="custom-prev" style={{ color: '#2c2c2c', fontSize: '3rem', position: 'absolute', top: '50%', left: 10, zIndex: 10, cursor: 'pointer' }}>‹</div>
            <div className="custom-next" style={{ color: '#2c2c2c', fontSize: '3rem', position: 'absolute', top: '50%', right: 10, zIndex: 10, cursor: 'pointer' }}>›</div>
          </div>
          <div className={styles.text}>
            <h3>{t('projects.flutter.title')}</h3>
            <p>{t('projects.flutter.description')}</p>
            <ul>
              <li>✓ {t('projects.flutter.feature1')}</li>
              <li>✓ {t('projects.flutter.feature2')}</li>
              <li>✓ {t('projects.flutter.feature3')}</li>
              <li>✓ {t('projects.flutter.feature4')}</li>
              <li>✓ {t('projects.flutter.feature5')}</li>
              <li>✓ <span className={styles.more}> {t('projects.flutter.more')}</span></li>

            </ul>
            <span className={styles.tech}>{t('projects.flutter.technologies')}</span>
          </div>
        </div>

        {/* مشروع Flexi */}
        <div className={styles.project}>
          <div className={styles.text}>
            <h3>{t('projects.flexi.title')}</h3>
            <p>{t('projects.flexi.description')}</p>
            <ul>
              <li>✓ {t('projects.flexi.feature1')}</li>
              <li>✓ {t('projects.flexi.feature2')}</li>
              <li>✓ {t('projects.flexi.feature3')}</li>
              <li>✓ {t('projects.flexi.feature4')}</li>
              <li>✓ {t('projects.flexi.feature5')}</li>
              <li>✓ <span className={styles.more}> {t('projects.flexi.more')}</span></li>

            </ul>
            <span className={styles.tech}>{t('projects.flexi.technologies')}</span>
          </div>

          <div className={styles.images}>
            <Swiper
              key={i18n.language}
              className={styles.customSwiper}
              navigation={{
                nextEl: '.custom-next',
                prevEl: '.custom-prev',
              }}
              pagination={{ clickable: true }}
              loop={true}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              modules={[Autoplay, Pagination, Navigation]}
            >
              {flexiImages.map((src, index) => (
                <SwiperSlide key={index}>
                  <img
                    src={src}
                    alt={`Flexi Project Image ${index + 1}`}
                    className={styles.projectImage}
                    style={{
                      width: '100%',

                      height: 'auto',
                      maxHeight: '300px', 
                      objectFit: 'contain',
                      borderRadius: '10px',
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="custom-prev" style={{ color: '#2c2c2c', fontSize: '3rem', position: 'absolute', top: '50%', left: 10, zIndex: 10, cursor: 'pointer' }}>‹</div>
            <div className="custom-next" style={{ color: '#2c2c2c', fontSize: '3rem', position: 'absolute', top: '50%', right: 10, zIndex: 10, cursor: 'pointer' }}>›</div>
          </div>
        </div>
      </div>
    </section>
  );
};
